"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.config = void 0;
var config = {
  recordURL: "/recordsservice/v1/api"
};
exports.config = config;